import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "value" }
const _hoisted_2 = { class: "footer-container" }
const _hoisted_3 = { class: "button-group" }

import TextBase, { TextType } from '@/design-system/atoms/TextBase.vue'
import CardInteractive from './CardInteractive.vue'
import AccordionExpander from '@/design-system/atoms/AccordionExpander.vue'
import { useI18n } from 'vue-i18n'
import { ref } from 'vue'
import ShowOnMapButton from './ShowOnMapButton.vue'
import { FormatOptions, formatter } from '../formatter'
import GaugeBase from '../../GaugeBase.vue'

export type Value =
  | { type: 'number'; number: number; textType?: TextType; format?: FormatOptions }
  | {
      type: 'gauge'
      number: number
      min?: number
      max?: number
      format?: FormatOptions
    }
  | { type: 'string'; string: string; textType?: TextType }
  | { type: 'icon'; icon: string }

export interface Props {
  title: string
  info?: string
  value?: Value
  color?: string
  showOnMapEnabled?: boolean
  showOnMap: boolean
  isLoading?: boolean
  fullscreen?: boolean
}

type Emits = {
  (e: 'toggleShowOnMap'): void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MeasurementBase',
  props: {
    title: {},
    info: { default: undefined },
    value: { default: () => ({ type: 'string', string: '-' }) },
    color: { default: 'red' },
    showOnMapEnabled: { type: Boolean, default: true },
    showOnMap: { type: Boolean },
    isLoading: { type: Boolean },
    fullscreen: { type: Boolean }
  },
  emits: ["toggleShowOnMap"],
  setup(__props: any, { emit: __emit }) {

const { t, locale } = useI18n()



const emits = __emit

const showDetails = ref(false)

function toggleShowOnMap() {
  emits('toggleShowOnMap')
}

function onAccordionClicked() {
  showDetails.value = !showDetails.value
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["measurement-card", { fullscreen: _ctx.fullscreen }])
  }, [
    _createVNode(CardInteractive, {
      title: _ctx.title,
      info: _ctx.info,
      titleType: "label",
      isLoading: _ctx.isLoading
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.showOnMapEnabled)
              ? (_openBlock(), _createBlock(ShowOnMapButton, {
                  key: 0,
                  active: _ctx.showOnMap,
                  onToggleShowOnMap: toggleShowOnMap
                }, null, 8, ["active"]))
              : _createCommentVNode("", true),
            (_ctx.$slots.details)
              ? (_openBlock(), _createBlock(AccordionExpander, {
                  key: 1,
                  text: _unref(t)('dashboard__text__show-details'),
                  textOpen: _unref(t)('dashboard__text__hide-details'),
                  size: "extrasmall",
                  active: showDetails.value,
                  onOnClicked: onAccordionClicked
                }, null, 8, ["text", "textOpen", "active"]))
              : _createCommentVNode("", true)
          ]),
          (showDetails.value)
            ? _renderSlot(_ctx.$slots, "details", { key: 0 })
            : _createCommentVNode("", true)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (_ctx.value.type === 'string')
            ? (_openBlock(), _createBlock(TextBase, {
                key: 0,
                text: _ctx.value.string,
                type: _ctx.value.textType ?? 'h3',
                color: _ctx.color,
                weight: "bold"
              }, null, 8, ["text", "type", "color"]))
            : (_ctx.value.type === 'number')
              ? (_openBlock(), _createBlock(TextBase, {
                  key: 1,
                  text: _unref(formatter)(_ctx.value.number, _unref(locale), _ctx.value.format),
                  type: _ctx.value.textType ?? 'h3',
                  color: _ctx.color,
                  weight: "bold"
                }, null, 8, ["text", "type", "color"]))
              : (_ctx.value.type === 'gauge')
                ? (_openBlock(), _createBlock(GaugeBase, {
                    key: 2,
                    value: _ctx.value.number,
                    min: _ctx.value.min,
                    max: _ctx.value.max,
                    format: _ctx.value.format,
                    color: _ctx.color
                  }, null, 8, ["value", "min", "max", "format", "color"]))
                : (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.value.icon), {
                    key: 3,
                    style: _normalizeStyle({ color: _ctx.color })
                  }, null, 8, ["style"]))
        ])
      ]),
      _: 3
    }, 8, ["title", "info", "isLoading"])
  ], 2))
}
}

})